/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".stockouts-col[_ngcontent-%COMP%]   .chart-card[_ngcontent-%COMP%]:hover, .stockouts-col[_ngcontent-%COMP%]   .data-card[_ngcontent-%COMP%]:hover{-webkit-transform:none;transform:none;box-shadow:0 4px 12px 0 rgba(0,0,0,.1)}"];
export { styles as styles };
